module.exports = __webpack_public_path__ + "img/undraw_Taken_re_yn20.0c6e8817.png";